<template>
    <v-dialog
      v-model="show"
      max-width="700px"
      persistent
    >
      <v-card class="pa-4">
        <v-card-title>
          <h2>
            Seguimientos personalizados
          </h2>
        </v-card-title>
        <v-card-text class="customer-tracking-logs-dialog__content">
          <customer-tracking-logs
            :show-skeleton="isLoading"
            :skeleton-rows="8"
            :customer-tracking-logs="customerTrackingLogs"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn color="black" class="ml-auto" flat @click.stop="closeModal">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import CustomerTrackingLogs from '@/components/customer/CustomerTrackingLogs';

export default {
  components: {
    CustomerTrackingLogs,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    customer: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      customerTrackingLogs: [],
      customerTrackingLogsTest: [
        {
          id: 1,
          body: `<strong>SEGUIMIENTO CERRADO</strong> el <strong>18/01/2024</strong> a las <strong>05:50 PM</strong><br>Seguimiento business de prueba cerrado #1`,
        },
        {
          id: 2,
          body: `<strong>SEGUIMIENTO CREADO</strong> para ser contactado el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong><br>Seguimiento business de prueba creado #1`,
        },
        {
          id: 3,
          body: `<strong>SEGUIMIENTO AGENDANDO</strong> para ser contactado el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong><br>Seguimiento business de prueba creado #1 Seguimiento business de prueba creado`,
        }, /*
        {
          id: 4,
          body: `<strong>SEGUIMIENTO GESTIONANDOSE</strong> el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong>`,
        },
        {
          id: 5,
          body: `<strong>SEGUIMIENTO RETRASADO</strong> el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong>`,
        },

        {
          id: 6,
          body: `<strong>SEGUIMIENTO CERRADO</strong> el <strong>18/01/2024</strong> a las <strong>05:50 PM</strong><br>Seguimiento business de prueba cerrado #1`,
        },
        {
          id: 7,
          body: `<strong>SEGUIMIENTO CREADO</strong> para ser contactado el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong><br>Seguimiento business de prueba creado #1`,
        },
        {
          id: 8,
          body: `<strong>SEGUIMIENTO AGENDANDO</strong> para ser contactado el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong><br>Seguimiento business de prueba creado #1 Seguimiento business de prueba creado`,
        },
        {
          id: 9,
          body: `<strong>SEGUIMIENTO GESTIONANDOSE</strong> el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong>`,
        },
        {
          id: 10,
          body: `<strong>SEGUIMIENTO RETRASADO</strong> el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong>`,
        },

        {
          id: 11,
          body: `<strong>SEGUIMIENTO CERRADO</strong> el <strong>18/01/2024</strong> a las <strong>05:50 PM</strong><br>Seguimiento business de prueba cerrado #1`,
        },
        {
          id: 12,
          body: `<strong>SEGUIMIENTO CREADO</strong> para ser contactado el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong><br>Seguimiento business de prueba creado #1`,
        },
        {
          id: 13,
          body: `<strong>SEGUIMIENTO AGENDANDO</strong> para ser contactado el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong><br>Seguimiento business de prueba creado #1 Seguimiento business de prueba creado`,
        },
        {
          id: 14,
          body: `<strong>SEGUIMIENTO GESTIONANDOSE</strong> el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong>`,
        },
        {
          id: 15,
          body: `<strong>SEGUIMIENTO RETRASADO</strong> el <strong>15/01/2024</strong> a las <strong>02:00 PM</strong>`,
        }, */
      ],
    };
  },
  methods: {
    closeModal() {
      this.$emit('close', false);
    },
    getCustomerTrackingLogs() {
      this.isLoading = true;
      this.axios.get(`customers_tracking/${this.customer.id}/logs`)
        .then(({ data }) => {
          this.$set(this, 'customerTrackingLogs', data);
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.getCustomerTrackingLogs();
      } else {
        this.$set(this, 'customerTrackingLogs', []);
      }
    },
  },
};
</script>

<style scoped>
.customer-tracking-logs-dialog__content .skeleton-container, .customer-tracking-logs {
  height: 330px !important;
  padding: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/CustomerTrackingLogsDialog.vue